
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { gql } from '@apollo/client';
import { client } from 'helpers/apollo';
import Memberships, { MembershipsProps } from 'library/pages/Memberships';
import { GetStaticProps } from 'next';
const MembeshipsIndex = (props: MembershipsProps) => <Memberships {...props}/>;
export default MembeshipsIndex;
export const getStaticPaths = async () => {
    return {
        paths: [],
        fallback: 'blocking'
    };
};
const getStaticProps: GetStaticProps = async ({ params, locale }) => {
    const widgetSlug = params?.widgetSlug as string;
    const widgetData = await fetchWidgetData(widgetSlug, locale as string);
    return {
        props: {
            memberships: widgetData?.outlet?.membership_products,
            outlet: widgetData?.outlet
        },
        revalidate: 1,
        notFound: !widgetData
    };
};
const fetchWidgetData = async (widgetSlug: string, locale: string) => {
    const { data } = await client.query({
        query: gql `
      query WidgetMembershipsFetchWidget(
        $widgetSlug: String
        $locale: String!
      ) {
        widgets(where: { slug: { _eq: $widgetSlug } }) {
          outlet_id
          id
          name
          outlet {
            slug
            name
            default_currency
            membership_key_image
            membership_products(where: { hide_from_public: { _eq: false } }) {
              id
              image
              translations(
                where: {
                  language: { _in: [$locale, "en"] }
                  field: { _in: ["name", "description"] }
                  model_type: { _eq: "Memberships::Product" }
                }
              ) {
                language
                field
                value_scrubbed
              }
            }
            feature_toggles {
              marketplace_enabled
            }
          }
        }
      }
    `,
        variables: { widgetSlug, locale }
    });
    return data?.widgets[0];
};

    async function __Next_Translate__getStaticProps__196f3659f8c__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[widgetSlug]/memberships/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196f3659f8c__ as getStaticProps }
  